import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 4,
  "data-testid": "plugin-icon-default",
  class: "rdicon icon-small plugin"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(_ctx.iconClass)
  }, [
    (_ctx.iconUrl)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          "data-testid": "plugin-icon-image",
          class: "plugin-icon",
          src: _ctx.iconUrl
        }, null, 8, _hoisted_1))
      : (_ctx.glyphicon)
        ? (_openBlock(), _createElementBlock("i", {
            key: 1,
            "data-testid": "plugin-icon-glyphicon",
            class: _normalizeClass('glyphicon glyphicon-' + _ctx.glyphicon)
          }, null, 2))
        : (_ctx.faicon)
          ? (_openBlock(), _createElementBlock("i", {
              key: 2,
              "data-testid": "plugin-icon-faicon",
              class: _normalizeClass('fas fa-' + _ctx.faicon)
            }, null, 2))
          : (_ctx.fabicon)
            ? (_openBlock(), _createElementBlock("i", {
                key: 3,
                "data-testid": "plugin-icon-fabicon",
                class: _normalizeClass('fab fa-' + _ctx.fabicon)
              }, null, 2))
            : (_openBlock(), _createElementBlock("i", _hoisted_2))
  ], 2))
}